import React from "react";
import { Link } from "react-router-dom";
import "./Style.css";

function Electric() {
  return (
    <section className="service-detail">

      {/* 🔥 HERO BANNER */}
        <section className="hero-banner">
          <img  src="/service/RuralElectrification.png" alt="" />

          <div className="hero-content">
            <h1>RURAL ELECTRIFICATION</h1>
            {/* <p>Swastika Infra Limited</p>   */}
          </div>
        </section>


      {/* 📄 CONTENT SECTION */}
        <div className="service-detail-content">

          <h2 className="service-heading">RURAL ELECTRIFICATION</h2>

          <p>
            Rural electrification is the process of bringing electrical power to
            rural and remote areas. Rural communities are disconnected from
            stable power supply due to inefficient and incomplete power
            infrastructure. Since last several years we have been involved in
            upgrading and building new infrastructure for rural India and we
            wish that rural communities will be able to reap considerable
            amounts of economic and social development by getting connected to
            power infrastructure.
          </p>

         

         

          {/* <h3 className="highlight-title">Key Highlights:</h3>

          <ul className="highlight-list">
            <li>Redevelopment of high-traffic railway stations</li>
            <li>Construction and upgrading of tracks and rail infrastructure</li>
            <li>Integration of advanced technologies for faster execution</li>
            <li>Alignment with modernization and smart mobility goals</li>
          </ul> */}


              <Link to="/service" className="back-btn">
                ← Back 
              </Link> 
        </div>

    </section>
  );
}

export default Electric;
